const Header = () => {
    return (
        <header>
            <div className="madurai-container">
                <div className="header">
                    <h1>MADURAI ASTROLOGY</h1>
                    <p>Accurate Thirukanitham astrology with Lahiri Ayanamsa</p>
                </div>
            </div>
        </header>
    );
};

export default Header;